import React, { useContext } from 'react';
import AuthContext from './context/AuthContext';
import RequesterDashboard from './RequesterDashboard';
import ProviderDashboard from './ProviderDashboard';

function Dashboard() {
    const { user } = useContext(AuthContext);

    if (user?.user_type === 'requester') {
        return <RequesterDashboard />;
    } else if (user?.user_type === 'provider') {
        return <ProviderDashboard />;
    }
    
    // در صورتی که کاربر لاگین نکرده باشد یا نوعش مشخص نباشد
    return <div>لطفا ابتدا وارد شوید.</div>;
}

export default Dashboard;